/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Field_RegionInputs */

const cs_addr_field_region = /** @type {(inputs: Addr_Field_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kraj`)
};

const en_addr_field_region = /** @type {(inputs: Addr_Field_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

/**
* | output |
* | --- |
* | "Region" |
*
* @param {Addr_Field_RegionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_field_region = /** @type {((inputs?: Addr_Field_RegionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Field_RegionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_field_region(inputs)
	return cs_addr_field_region(inputs)
});